import { NavLink } from "react-router-dom";
import { Box, Drawer, IconButton, Stack, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import { Section } from "../../styles/Layout";
import { colors } from "../../theme";
import logoSvg from "../../assets/logo.svg";
import { NavItem, NavItemContainer } from "./styles";
import MobileNavItemDropdown from "./MobileNavItemDropdown";

type Props = {
  onClose: () => void;
  open: boolean;
};

const MobileNavDrawer = ({ onClose, open }: Props) => {
  return (
    <Drawer anchor="left" open={open} onClose={onClose}>
      <Box
        bgcolor={colors.light}
        width={{ xs: "85vw", md: "45vw" }}
        height="auto"
        minHeight="100%"
        border={`2px solid ${colors.dark}`}
        overflow="auto"
      >
        <Section padding={2} direction="row" justifyContent="space-between" alignItems="center" flexWrap="nowrap">
          <IconButton onClick={onClose} style={{ width: "50px", height: "50px" }}>
            <Close color="primary" fontSize="large" />
          </IconButton>
          <NavLink to="/" style={{ padding: "0 32px" }} onClick={onClose}>
            <img src={logoSvg} alt="luckington farm" />
          </NavLink>
          <div style={{ minWidth: "50px" }}></div>
        </Section>

        <Stack paddingY={4} paddingX={2}>
          <NavItem to="/" onClick={onClose}>
            <NavItemContainer>
              <Typography>HOME</Typography>
            </NavItemContainer>
          </NavItem>
          <MobileNavItemDropdown
            title="SHOP"
            items={[
              { to: "/shop/poultry", title: "POULTRY" },
              { to: "/shop/beef", title: "BEEF" },
              { to: "/shop/lamb", title: "LAMB" },
            ]}
            onClose={onClose}
          />
          <NavItem to="/about" onClick={onClose}>
            <NavItemContainer>
              <Typography>ABOUT</Typography>
            </NavItemContainer>
          </NavItem>
          <NavItem to="/recipes" onClick={onClose}>
            <NavItemContainer>
              <Typography>RECIPES</Typography>
            </NavItemContainer>
          </NavItem>
          <NavItem to="/contact" onClick={onClose}>
            <NavItemContainer>
              <Typography>CONTACT</Typography>
            </NavItemContainer>
          </NavItem>

          <a href="https://www.instagram.com/luckingtonfarm/" target="_blank" rel="noreferrer">
            <NavItemContainer>
              <Typography>@LUCKINGTONFARM</Typography>
            </NavItemContainer>
          </a>
        </Stack>
      </Box>
    </Drawer>
  );
};

export default MobileNavDrawer;
